import { Box, Typography } from '@mui/material';
import React from 'react';
import {
  BILLING_TAB,
  NEW_TAB_TOOLTIP,
  PENDING_TAB_TOOLTIP,
  RECURRING_TAB_TOOLTIP,
} from 'components/TeamOverview/BillingSection/utilities/constants';
import { TransactionTypeSelector } from 'components/TeamOverview/BillingSection/views/components/TransactionTypeSelector';
import { useBillingSectionHeaderStyles } from 'components/TeamOverview/BillingSection/styles';
import { useTeamBlocksBilling } from 'components/TeamOverview/BillingSection/hooks/useTeamBlocksBilling';
import { countBlocks } from 'components/TeamOverview/BillingSection/utilities/utilities';

export const BillingSectionHeader = ({ team, filter, setFilter }) => {
  const { classes } = useBillingSectionHeaderStyles();
  // TODO: remove after backend updates
  // const [type, setType] = useState(BILLING_QUEUE_TYPE);

  const { blocksBillings } = useTeamBlocksBilling(team);

  const blocksCounter = countBlocks(blocksBillings);

  const TABS = [
    {
      value: BILLING_TAB.ALL,
      label: `View all (${blocksCounter.all})`,
    },
    {
      value: BILLING_TAB.NEW,
      label: `freemium (${blocksCounter.freemium})`,
      tooltip: NEW_TAB_TOOLTIP,
    },
    {
      value: BILLING_TAB.PENDING,
      label: `Freemium Ending (${blocksCounter.pending})`,
      tooltip: PENDING_TAB_TOOLTIP,
    },
    {
      value: BILLING_TAB.RECURRING,
      label: `in-storage (${blocksCounter.inStorage})`,
      tooltip: RECURRING_TAB_TOOLTIP,
    },
  ];

  return (
    <Box className={classes.header}>
      <Box display="flex" alignItems="center">
        <Typography fontSize="1.125rem" fontWeight={500}>
          BLOCKS TRACKING
        </Typography>
        {/* TODO: uncomment after backend updates */}
        {/* <UpcomingBillingInfo team={team} /> */}
      </Box>
      <TransactionTypeSelector
        currentTabValue={filter}
        handleTabChange={(e, v) => setFilter(v)}
        tabsList={TABS}
      />
      {/* TODO: uncomment after backend updates */}
      {/* <Dropdown value={type} setValue={setType} /> */}
    </Box>
  );
};
